import { FAIcon, Theme, SearchDataStructure, AttributeTypes, Tag, TagStyle } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
//import { dateTimeToCustomFormat } from '../../../ui/utils';
import { DynamicObjectInterface } from '../../../sdk/type';

export interface SearchedUserData {
  userId: number;
  name: string;
  email: string;
  phone: string | null;
  status: string;
  pinLevel: string;
  userPinName: string;
  directLeaderId: number;
  directLeaderName: string;
  directLeaderPinLevel: number;
  directLeaderPinName: string;
}

type ICoachEnrollmentBO = {
  [key: string]: DynamicObjectInterface;
};

const dataSearchOption: SearchDataStructure[] = [
  {
    name: 'Coach ID',
    key: 'coachId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  // {
  //   name: 'ABO ID',
  //   key: 'coachAboId',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  {
    name: 'Coach Name',
    key: 'coachName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  // {
  //   name: 'Current Pin',
  //   key: 'coachPin',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  // {
  //   name: 'Direct Leader',
  //   key: 'directLeader',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  // {
  //   name: 'Direct Leader ABO ID',
  //   key: 'directLeaderAboId',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
  // {
  //   name: 'Status',
  //   key: 'status',
  //   type: AttributeTypes.DropdownSingleSelect,
  //   visibility: false,
  //   dataset: [
  //     {
  //       key: 'ACTIVE',
  //       value: 'ACTIVE',
  //     },
  //     {
  //       key: 'INACTIVE',
  //       value: 'INACTIVE',
  //     },
  //   ],
  // },
  // {
  //   name: 'Remark',
  //   key: 'remark',
  //   type: AttributeTypes.Textbox,
  //   visibility: false,
  // },
];

const getCoachEnrollemntListConfig: GetColumnsType = (
  styles: Object,
  translation: Function,
  cb: DynamicObjectInterface,
) => [
  {
    key: 'campaignId',
    text: translation('admin.coachEnrollmentMaster.campaignId'),
    width: 10,
    sortable: true,
    render: (object: ICoachEnrollmentBO) => <span>{object.campaignId}</span>,
  },
  {
    key: 'coachId',
    text: translation('admin.coachEnrollmentMaster.coachId'),
    sortable: true,
    width: 10,
    render: (object: ICoachEnrollmentBO) => <span>{object.coachId}</span>,
  },
  // {
  //   key: 'coachAboId',
  //   text: translation('admin.coachEnrollmentMaster.coachAboId'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => <span>{object.coachAboId}</span>,
  // },
  {
    key: 'name',
    text: translation('admin.coachEnrollmentMaster.coachName'),
    sortable: true,
    width: 10,
    render: (object: ICoachEnrollmentBO) => <span>{object.coachName}</span>,
  },
  // {
  //   key: 'currentPin',
  //   text: translation('admin.coachEnrollmentMaster.coachPin'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => <span>{object.coachPin}</span>,
  // },
  // {
  //   key: 'directLeaderName',
  //   text: translation('admin.coachEnrollmentMaster.directLeaderName'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => <span>{object.directLeaderName}</span>,
  // },
  {
    key: 'directLeader',
    text: translation('admin.coachEnrollmentMaster.directLeaderShort'),
    sortable: true,
    width: 10,
    render: (object: ICoachEnrollmentBO) => <span>{object.directLeader}</span>,
  },
  // {
  //   key: 'rollingMonth',
  //   text: translation('admin.coachEnrollmentMaster.enrollmentRollingMonthShort'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => <span>{object.rollingMonth ?? object.validity}</span>,
  // },
  // {
  //   key: 'enrollmentDate',
  //   text: translation('admin.coachEnrollmentMaster.enrollmentDateShort'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => (
  //     <span>{object.enrollmentDate ? dateTimeToCustomFormat(object.enrollmentDate?.toString(), 'MMM YYYY') : ''}</span>
  //   ),
  // },
  // {
  //   key: 'enrollmentDate',
  //   text: translation('admin.coachEnrollmentMaster.period'),
  //   sortable: true,
  //   width: 15,
  //   render: (object: ICoachEnrollmentBO) => (
  //     <span>
  //       {object.enrollmentDate
  //         ? dateTimeToCustomFormat(object.enrollmentDate?.toString(), 'MMM YYYY') +
  //           ' to ' +
  //           dateTimeToCustomFormat(object.endDate?.toString(), 'MMM YYYY')
  //         : ''}
  //     </span>
  //   ),
  // },
  {
    key: 'status',
    text: translation('admin.coachEnrollmentMaster.status'),
    sortable: true,
    width: 10,
    render: (object: ICoachEnrollmentBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  // {
  //   key: 'remark',
  //   text: translation('admin.coachEnrollmentMaster.remark'),
  //   sortable: true,
  //   width: 10,
  //   render: (object: ICoachEnrollmentBO) => <span>{object.remark}</span>,
  // },
  {
    key: 'action',
    width: 5,
    text: 'Actions',
    render: (object: ICoachEnrollmentBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.recId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onDelete(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export default getCoachEnrollemntListConfig;
export { dataSearchOption };
